<template>
  <div class="row m-b-10">
    <label for="status" class="col-form-label p-l-10">Status:</label>
    <div class="col-auto p-t-5">
      <select id="status" aria-controls="lang_opt" class="col-auto form-control form-control-sm rounded" name="lang_opt_length" :value="value" @change="$emit('input', $event.target.value)">
        <option v-for="status in statusList" :key="status" :value="status">
          {{ status }}
        </option>
        <option value="">
          All
        </option>
      </select>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StatusFilter',
  props: ['value', 'statusList']
}
</script>

<style scoped>
</style>
